import {
  HeaderBreadcrumbs,
  MultiSectionLayout,
  TextInput,
} from "@jugl-web/ui-components";
import { Button } from "@jugl-web/ui-kit";
import React from "react";
import { TextAreaInput } from "@jugl-web/ui-components/cross-platform/forms/TextAreaInput";
import { useNavigation } from "@web-src/modules/navigation/hooks/useNavigation";
import { useTranslations } from "@jugl-web/utils";
import { ReactComponent as ArrowIcon } from "./assets/arrow.svg";
import { SectionHeader } from "./components/SectionHeader";

export const CXActionsFormPage: React.FC = () => {
  const { t } = useTranslations();
  const { navigateToPage } = useNavigation();

  return (
    <MultiSectionLayout
      header={
        <HeaderBreadcrumbs
          items={[
            {
              title: t({
                id: "cx-actions-form-page.actions",
                defaultMessage: "Actions",
              }),
              onClick: () => navigateToPage("cxActions"),
            },
            {
              title: t({
                id: "cx-actions-form-page.new-action",
                defaultMessage: "New Action",
              }),
            },
          ]}
        />
      }
    >
      <MultiSectionLayout
        classNames={{
          rightSide:
            "min-w-[474px] h-full border-dark-100 border-0 border-l border-solid",
          content: "h-full max-w-[1030px] bg-grey-100",
        }}
        rightSide={
          <div
            className="h-full"
            style={{
              backgroundImage:
                "radial-gradient(circle, #E1E4E6 1px, transparent 1.5px)",
              backgroundSize: "20px 20px",
            }}
          />
        }
      >
        <div className="flex h-full flex-col gap-8 p-8">
          <div className="flex items-center gap-2">
            <div className="w-[22px]" />
            <span className="font-secondary text-[22px] font-semibold text-[#1A2023]">
              {t({
                id: "cx-actions-form-page.shopify-action",
                defaultMessage: "Shopify Action",
              })}
            </span>
          </div>
          <div className="flex flex-col gap-10 rounded-2xl bg-white p-8">
            <div className="flex flex-col gap-4">
              <SectionHeader
                title={t({
                  id: "cx-actions-form-page.action-name",
                  defaultMessage: "Action name",
                })}
                description={t({
                  id: "cx-actions-form-page.action-name-description",
                  defaultMessage:
                    "Set a clear name for this action to help the AI Agent understand when to use it.",
                })}
              />
              <TextInput />
            </div>
            <div className="flex flex-col gap-4">
              <SectionHeader
                title={t({
                  id: "cx-actions-form-page.when-how-agent-act",
                  defaultMessage: "When & how should AI Agent act?",
                })}
                description={t({
                  id: "cx-actions-form-page.when-how-agent-act-description",
                  defaultMessage:
                    "Define when the action should be triggered and how the AI Agent should handle it in conversations. Add details and example request",
                })}
              />
              <TextAreaInput classNames={{ inputClassName: "min-h-[220px]" }} />
            </div>
            <div className="flex items-center gap-4">
              <Button className="w-[200px]" iconEnd={<ArrowIcon />}>
                {t({
                  id: "cx-actions-form-page.save-and-enable",
                  defaultMessage: "Save & Enable",
                })}
              </Button>
              <Button className="w-[120px]" variant="secondary">
                {t({
                  id: "common.save",
                  defaultMessage: "Save",
                })}
              </Button>
            </div>
          </div>
        </div>
      </MultiSectionLayout>
    </MultiSectionLayout>
  );
};
